import { HOSTNAME } from "../constants/constants";
import { fetcher } from "../utils/utils";
import useSWR from "swr";

export const useJobs = (lang) => {
  const { data, error, isLoading } = useSWR(
    `${HOSTNAME}/jobs?locale=${lang}`,
    fetcher
  );

  return {
    jobsData: data,
    isJobsLoading: isLoading,
    jobsError: error
  }
}

export const useJobsContent = (lang) => {
  const { data, error, isLoading } = useSWR(
    `${HOSTNAME}/jobs-page?populate=*&locale=${lang}`,
    fetcher
  );

  return {
    jobsContentData: data,
    isJobsContentLoading: isLoading,
    jobsContentError: error
  }
}

export const useFormData = (lang) => {
  const { data, error, isLoading } = useSWR(
    `${HOSTNAME}/form?populate=deep,10&locale=${lang}`,
    fetcher
  );

  return {
    formFields: data,
    isFormFieldsLoading: isLoading,
    formFieldsError: error
  }
}

export const useJob = (id, lang) => {
  const { data, error, isLoading } = useSWR(
    `${HOSTNAME}/jobs/${id}?populate=*&locale=${lang}`,
    fetcher
  );

  return {
    jobData: data,
    isJobLoading: isLoading,
    jobError: error
  }
}

export const useGamesContent = (lang) => {
  const { data, error, isLoading } = useSWR(
    `${HOSTNAME}/games-page?populate=*&locale=${lang}`,
    fetcher
  );

  return {
    gamesContent: data,
    isGamesContentLoading: isLoading,
    gamesContentError: error
  }
}
export const useGames = (lang) => {
  const { data, error, isLoading } = useSWR(
    `${HOSTNAME}/games?populate[images_for_preview_block][populate][0]=main_image,other_images&locale=${lang}`,
    fetcher
  );

  return {
    gamesData: data,
    isGamesLoading: isLoading,
    gamesError: error
  }
}
export const useGame = (id, lang) => {
  const { data, error, isLoading } = useSWR(
    `${HOSTNAME}/games/${id}?populate=*&locale=${lang}`,
    fetcher
  );

  return {
    gameData: data,
    isGameLoading: isLoading,
    gameError: error
  }
}

export const useAbout = (lang) => {
  const { data, error, isLoading } = useSWR(
    `${HOSTNAME}/about?populate=deep,10&locale=${lang}`,
    fetcher
  );

  return {
    aboutData: data,
    isAboutLoading: isLoading,
    aboutError: error
  }
}

export const useTerms = (lang) => {
  const { data, error, isLoading } = useSWR(
    `${HOSTNAME}/terms-of-use?populate=deep,10&locale=${lang}`,
    fetcher
  );

  return {
    termsData: data,
    isTermsLoading: isLoading,
    termsError: error
  }
}
export const usePrivacy = (lang) => {
  const { data, error, isLoading } = useSWR(
    `${HOSTNAME}/privacy?populate=deep,10&locale=${lang}`,
    fetcher
  );

  return {
    privacyData: data,
    isPrivacyLoading: isLoading,
    privacyError: error
  }
}

export const useMission = (lang) => {
  const { data, error, isLoading } = useSWR(
    `${HOSTNAME}/mission?populate=deep,10&locale=${lang}`,
    fetcher
  );

  return {
    missionData: data,
    isMissionLoading: isLoading,
    missionError: error
  }
}

export const useHome = (lang) => {
  const { data, error, isLoading } = useSWR(
    `${HOSTNAME}/home?populate=deep,10&locale=${lang}`,
    fetcher
  );

  return {
    homeData: data,
    isHomeLoading: isLoading,
    homeError: error
  }
}

export const useContacts = (lang) => {
  const { data, error, isLoading } = useSWR(
    `${HOSTNAME}/contact?populate=deep,10&locale=${lang}`,
    fetcher
  );

  return {
    contactsData: data,
    isContactsLoading: isLoading,
    contactsError: error
  }
}